import { ChangeDetectionStrategy, Component, effect, input, WritableSignal } from '@angular/core';
import { NgClass } from '@angular/common';
import { MaterialIconComponent, TooltipOnContentOverflowDirective } from '@ps-gui/shared-core';
import { Subject } from 'rxjs';

export interface Checkbox<T> {
  text: string;
  value: T;
  checked: WritableSignal<boolean>;
}

@Component({
  selector: 'shared-ui-checkbox',
  imports: [NgClass, MaterialIconComponent, TooltipOnContentOverflowDirective],
  templateUrl: './checkbox.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckboxComponent<T> {
  readonly checkbox = input.required<Checkbox<T>>();

  /**
   * This input is only necessary for popups containing checkboxes. The calculation in
   * TooltipOnContentOverflowDirective does not work properly when inside an absolutely
   * positioned popup, so we need to retrigger it once the popup is opened.
   */
  readonly refreshDisplayText = input<boolean>(false);

  readonly backgroundColorTailwindClass = input('bg-primary');
  readonly borderColorTailwindClass = input('border-primary');
  readonly size = input('16px');
  readonly checkColorTailwindClass = input('text-white');
  readonly textWidthClass = input('w-[260px]');

  protected readonly reevaluationSubject = new Subject<boolean>();

  constructor() {
    effect(() => {
      this.reevaluationSubject.next(this.refreshDisplayText());
    });
  }

  protected toggle() {
    this.checkbox().checked.set(!this.checkbox().checked());
  }
}
